export default {
  funcao(valor) : String {
    switch (valor) {
      case 'Cirurgiao':
        return 'Médico Principal'
      case 'PrimeiroAuxiliar':
        return '1° Auxiliar'
      case 'SegundoAuxiliar':
        return '2° Auxiliar'
      case 'TerceiroAuxiliar':
        return '3° Auxiliar'
      case 'QuartoAuxiliar':
        return '4° Auxiliar'
      case 'Instrumentador':
        return 'Instrumentador'
      case 'Anestesista':
        return 'Anestesista'
      default:
        return ''
    }
  },
}
